import React from 'react';
import request from 'superagent';
import slug from 'slug';
import Modal from 'react-responsive-modal';
import { Link } from 'react-router';
import surgeryTexts from '../../../texts/czech/surgery';

import './Header.scss';

import gdprText from './newsletters';

import logo from '../../../assets/img/logo.png';

import config from '../../../constants/config';

class Header extends React.Component {
  constructor(props) {
    super(props);

    if (window && window.addEventListener) {
      window.addEventListener("scroll", this.handleScroll);
    }

    this.state = {
      headerScrolled: false,
      headerFinder: false,
      openedMenu: false,
      openedLangDropdown: false,
      activeLang: "CZ",
      gdprOpened: false,
      results: [],
      finderInput: "",
      finderResultsVisible: false,
      email: ""
    };

    this.interval = null;
  }

  componentWillUnmount() {
    document.body.className = "";
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const topOffset = document.documentElement.scrollTop;

    if (topOffset > 50 && this.state.headerScrolled === false) {
      this.setState({
        headerScrolled: true
      })
    } else if (topOffset < 50 && this.state.headerScrolled === true) {
      this.setState({
        headerScrolled: false
      });
    }
  };

  renderLink = (path, label, keyWord) => {
    const page = this.props.page;
    const className = (path === page || page.indexOf(keyWord) > -1)
      ? "active" : "";
    return <Link onClick={this.hideMenu} to={path} className={className}>{label}</Link>
  };

  renderLinks = () => {
    return (
      <div>
        {this.renderLink("/", "Domů")}
        {this.renderLink("/zakroky", "Zákroky", 'zakrok')}
        {this.renderLink("/lekari", "Lékaři", 'lekar')}
        {this.renderLink("/partneri", "Partneři", 'partner')}
        {this.renderLink("/poradna", "Poradna", "poradna")}
        {this.renderLink("/galerie", "Galerie")}
        {this.renderLink("/cenik", "Ceník")}
        {this.renderLink("/kontakt", "Kontakt")}
      </div>
    )
  };

  toggleLangDropdown = () => {
    this.setState({
      openedLangDropdown: !this.state.openedLangDropdown
    })
  };

  langChanged = (lang) => {
    this.toggleLangDropdown();
    this.setState({
      activeLang: lang
    })
  };

  renderLangs = () => {
    //const langs = ["CZ", "PL", "EN", "IT", "RU"]; //todo: TESTING
    const langs = ["CZ"];
    const headerLangsClass = "header_langs" + (this.state.openedLangDropdown ? " active" : "");
    return (
      <div className={headerLangsClass}>
        <div className="header_langs_dropdown">
          <span onClick={this.toggleLangDropdown}>{this.state.activeLang}</span>
          <ul className="header_langs_list">
            {langs.map(lang => {
              if (this.state.activeLang === lang) return <React.Fragment key={lang}/>;
              return <li onClick={() => this.langChanged(lang)} key={lang}>{lang}</li>;
            })}
          </ul>
        </div>
      </div>
    )
  };

  changeEmail = (e) => {
    this.setState({
      email: e.target.value
    })
  }

  toggleFinder = () => {
    this.setState({
      headerFinder: !this.state.headerFinder
    });
  };

  hideMenu = () => {
    document.body.className = "";
    this.setState({
      openedMenu: false
    })
  };

  toggleMenu = () => {
    document.body.className = this.state.openedMenu ? "" : "bodyFixed";

    this.setState({
      openedMenu: !this.state.openedMenu
    })
  };

  onCloseModal = () => {
    this.setState({
      gdprOpened: false
    })
  };

  onFinderChange = (e) => {
    this.setState({finderInput: e.target.value});
    if (this.interval) clearInterval(this.interval);

    this.interval = setInterval(() => {
      let results = [];
      const words = this.state.finderInput.split(" ");
      surgeryTexts.forEach(surgery => {
        surgery.procedures.forEach(procedure => {
          const procedureName = procedure.name.toLowerCase();
          const procedureText = procedure.text.toLowerCase();

          let isIncluded = true;

          words.forEach(word => {
            if (!(procedureName.includes(word) || procedureText.includes(word))) {
              isIncluded = false;
            }
          });

          if (isIncluded) {
            const isAlreadyInArray = results.find(res => (res.surgeryId === surgery.id && res.procedureId === procedure.id));

            const slugSurgery = slug(surgery.name, {lower: true});
            const slugProcedure = slug(procedure.name, {lower: true});

            if (!isAlreadyInArray)
              results.push({
                surgeryId: surgery.id,
                procedureId: procedure.id,
                text: procedure.name,
                link: `/zakrok/${slugSurgery}/${slugProcedure}`
              });
          }
        });
      });

      this.setState({results, finderResultsVisible: true});

      if (!this.state.finderInput.length) this.setState({finderResultsVisible: false});

      clearInterval(this.interval);
    }, 1500);
  };

  submitNewsletters = (e) => {
    e.preventDefault();
    if (this.state.email.trim().length === 0 || this.state.email.indexOf("@") === -1) return;
    this.setState({
      gdprOpened: true
    })
  };

  saveEmail = () => {
    request.post(config.apiUrl + 'saveEmail')
      .send({
        email: this.state.email
      })
      .type('form')
      .set('Accept', 'application/x-www-form-urlencoded')
      .then((res) => {
        this.setState({
          loading: false
        });

        if (res.text === "FAIL") {
          swal({
            title: "Chyba!",
            text: "Nastala chyba v přihlášení odběru!",
            icon: "error",
          });
        } else {
          swal({
            title: "Hotovo!",
            text: "Byl jste úspěšně přihlášen k odběru!",
            icon: "success",
          });
        }

        this.setState({
          email: "",
          gdprOpened: false
        });
      })
  };

  render() {
    const headerScrolled = this.state.headerScrolled;
    const headerScrolledClasses = "header no-print " + (headerScrolled ? "scrolled" : "");

    const toggleFinder = this.state.headerFinder;
    const toggleFinderClass = "header_top_finder " + (toggleFinder ? "active" : "");

    const respMenu = this.state.openedMenu;
    const hamburgerClass = "hamburger_menu " + (respMenu ? "active" : "");
    const headerMenuClass = "header_menu " + (respMenu ? "respActive" : "");

    return (
      <div>
        <header className={headerScrolledClasses}>
          <div className="header_top no-print">
            <div className="container">
              <div className="header_top_inner">
                <span className="hidden-sm">ZASÍLÁNÍ NEWSLETTERŮ</span>
                <div className="header_top_newsletter no-print">
                  <form onSubmit={this.submitNewsletters}>
                    <input type="text" placeholder="Vaše emailová adresa" value={this.state.email}
                           onChange={this.changeEmail}/>
                    <button type="submit">Přihlásit k odběru</button>
                  </form>
                </div>

                <div className={toggleFinderClass}>
                  <input type="text" placeholder="Hledejte..." onChange={this.onFinderChange} value={this.state.finderInput}/>
                  <a role="button" onClick={this.toggleFinder} className="header_top_finder_btn"><i className="llc-find"/></a>
                </div>
                {/*<a href="#" className="llc-twitter-logo-silhouette"/>
              <a href="#" className="llc-instagram"/>*/}

                <a
                  href="https://www.facebook.com/KLINIKA-LLC-PLASTICK%C3%81-CHIRURGIE-A-LASEROV%C3%89-L%C3%89%C4%8CEBN%C3%89-CENTRUM-114194068604606/"
                  target="_blank" className="llc-facebook-logo no-print"/>
              </div>
            </div>
          </div>

          <div className="header_bottom clearfix no-print">
            <div className="container relative">
              <Link className="header_logo no-print" to="/"><img src={logo}/></Link>

              <div className={hamburgerClass} onClick={this.toggleMenu}>
                <div>
                  <span/>
                  <span/>
                  <span/>
                </div>
              </div>

              {/*
            <div className="header_langs">
              <i className="llc-global"/>
              <Link to="/">CZ</Link>
              <Link to="/">EN</Link>
            </div>
            */}

              <div className={headerMenuClass}>
                {this.renderLinks()}
                {this.renderLangs()}
              </div>
            </div>
          </div>

          <Modal open={this.state.gdprOpened}
                 onClose={this.onCloseModal}
                 classNames={{
                   'modal': 'homeSales_modal',
                   'closeButton': 'homeSales_modal_close',
                 }}
          >
            <div dangerouslySetInnerHTML={{__html: gdprText}}/>
            <div className="text-center">
              <button onClick={this.saveEmail} className="btn">Souhlasím s podmínkami</button>
            </div>
          </Modal>

          {(this.state.results.length && this.state.finderResultsVisible) &&
          <div className="container relative">
            <div className="header_finder">
              {this.state.results.map(result => {
                return <Link className="header_finder_item" to={result.link} onClick={() => this.setState({finderResultsVisible: false})}>
                  {result.text}
                </Link>
              })}
            </div>
          </div>
          }
        </header>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Header.js